let yaAviso = false;

export function resolveApiBaseUrlFromEnv(raw: string | undefined): string {
  const recortado = (raw ?? '').trim();
  if (!recortado) {
    return '/api';
  }

  const sinBarraFinal = recortado.replace(/\/+$/, '');
  if (!sinBarraFinal) {
    return '/api';
  }

  const esRutaRelativa = sinBarraFinal.startsWith('/');
  const esHttps = sinBarraFinal.startsWith('https://');
  const esLocalDesarrollo = /^http:\/\/(localhost|127\.0\.0\.1)(:\d+)?(\/|$)/.test(sinBarraFinal);

  if (esRutaRelativa || esHttps || esLocalDesarrollo) {
    return sinBarraFinal;
  }

  if (!yaAviso) {
    console.warn(`VITE_API_BASE_URL inválida ("${raw}"), se usa /api por defecto.`);
    yaAviso = true;
  }

  return '/api';
}

/** Solo para pruebas: el aviso de VITE_API_BASE_URL inválida debe quedar en /api dentro de cada test, no según el orden. */
export function __resetAvisoApiBaseUrlParaPruebas(): void {
  yaAviso = false;
}
